<template>
  <main>
    <div class="container">
      <div class="row py-3 py-sm-5">
        <div class="col-12">
          <h1 class="text-white text-center">
            Create your Food Fitness First, Inc.® Account
          </h1>
        </div>
      </div>
    </div>

    <div class="container-fluid bg-white-trans py-3 mb-3 mb-sm-5">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <p class="lead text-center">
              Whether you are looking for yourself, or to educate those around you, sign up for a FFF membership and see how easy it can be to improve health results!
            </p>
            <p>From individuals to parents, corporations, health professionals, schools, food service departments and more, Food Fitness First, Inc.® provides unique and helpful tools to improve health and wellbeing.</p>
            <p>Our simple and easy to use online platform includes a variety of useful material, including, but not limited to, informative blogs, healthy recipes targeted at specific diseases/conditions, educational handouts, health assessments, health scorecards, books, bi-folds, and much more.</p>
            <p class="lead text-center">
              <strong>Select the membership option that best suits your needs below to get started!</strong>
            </p>
            <p>
              If you have questions about which membership is right for you, contact us <router-link :to="{name: 'contact'}">
                here
              </router-link>, and we will guide you in the right direction!
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <notifications />
      <div class="row d-flex pb-3 pb-sm-5 justify-content-center">
        <div class="col-12 col-md-6 col-lg-4 d-flex align-items-stretch">
          <div class="card mb-3 w-100">
            <div class="card-header">
              <h4 class="card-title text-center m-0">
                Individual
              </h4>
            </div>
            <div class="card-body text-center">
              <p>
                Whether you want to prevent and/or manage a chronic disease(s), are currently receiving medical care,
                or have your own reason(s) for needing help living a healthier lifestyle, our FOOD SPIRAL® wellness
                program membership can benefit YOU!
              </p>
            </div>
            <div class="card-footer text-center">
              <router-link
                :to="{name: 'signup.individual'}"
                class="btn btn-success btn-md"
              >
                Learn More
              </router-link>
            </div>
          </div>
        </div>
        <div
          v-if="!isCordova"
          class="col-12 col-md-6 col-lg-4 d-flex align-items-stretch"
        >
          <div class="card mb-3 w-100">
            <div class="card-header">
              <h4 class="card-title text-center m-0">
                Professional
              </h4>
            </div>
            <div class="card-body text-center">
              <p>
                This membership is designed for <strong>health professionals</strong> (working in physician's clinics, long term care
                centers, hospitals, dialysis centers, private practice, etc.), <strong>corporations</strong> (small or large businesses),
                and <strong>schools</strong>. Designated professionals will then be trained to become an instructor of one or more
                FOOD SPIRAL® programs in order to educate others within their community.
              </p>
            </div>
            <div class="card-footer text-center">
              <router-link
                :to="{name: 'signup.professional'}"
                class="btn btn-custom-outline"
              >
                Learn More
              </router-link>
            </div>
          </div>
        </div>
        <div
          v-if="!isCordova"
          class="col-12 col-md-6 col-lg-4 d-flex align-items-stretch"
        >
          <div class="card mb-3 w-100">
            <div class="card-header">
              <h4 class="card-title text-center m-0">
                Food Service
              </h4>
            </div>
            <div class="card-body text-center">
              <p>This membership is designed for foodservice staff in need of resources and materials related to the foodservice industry.</p>
            </div>
            <div class="card-footer text-center">
              <router-link
                :to="{name: 'signup.foodservice'}"
                class="btn btn-custom-outline"
              >
                Learn More
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid bg-white-trans py-3">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <p><em>You may NOT make copies or share Food Fitness First, Inc.® registered information with outside sources. Our program memberships are for individual purchase only. Materials are copyrighted and violators will be prosecuted. </em></p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  computed: {
    isCordova() {
      return this.$isCordova;
    }
  },
}
</script>

<style lang="scss">
.btn-custom-outline {
    /* .btn-success */
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;

    @media screen and (max-width: 1000px) {
        /* .btn-outline-success */
        color: #28a745;
        border-color: #28a745;
        background-color: transparent;
    }
}
</style>
